import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import { LIST_SUBSCRIPTIONS_RESOURCE } from 'src/features/subscriptions/api/useListSubscriptions';
import { subscriptionsMessages } from 'src/features/subscriptions/utils/messages';
import SubscriptionFormModal from 'src/features/subscriptions/components/forms/SubscriptionFormModal';
import { useCreateSubscription } from 'src/features/subscriptions/api/useCreateSubscription';

interface CreateSubscriptionFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateSubscriptionFormModal<TData>({ className, semantics }: CreateSubscriptionFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useCreateSubscription({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_SUBSCRIPTIONS_RESOURCE] });
            toast({
                title: formatMessage(subscriptionsMessages.createSubscriptionSuccess),
                description: formatMessage(subscriptionsMessages.createSubscriptionSuccessDescription),
            });
        },
    });

    return (
        <SubscriptionFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate(values, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(subscriptionsMessages.addSubscriptionSubtitle)}
        />
    );
}

export default CreateSubscriptionFormModal;
